import { FormikProps } from "formik";

export type RegistrationFormData = {
  emailAddress: string;
  verificationCode: string;
  password: string;
  passwordConfirmation: string;
  firstName: string;
  lastName: string;
};

export enum RegistrationFormSteps {
  EmailAddress,
  EmailVerification,
  Password,
  Names,
}

export type RegistrationStepProps = {
  currentStep: RegistrationFormSteps;
  formikProps: FormikProps<RegistrationFormData>;
};
